import { Pipe, PipeTransform } from '@angular/core';
import { DatePipe } from '@angular/common';

@Pipe({
  name: '_dateFormatHelperPipe'
})
export class DateFormatHelperPipe implements PipeTransform {

  constructor(private datePipe: DatePipe) { }

  transform(date: string): string | null {
    return this.datePipe.transform(date, 'yyyy/MM/dd', 'en-ZA') || null;
  }
  }
